import routerOptions0 from "/Users/xnng/code/sre/official/official_website/node_modules/.pnpm/nuxt@3.21.10_@parcel+watcher@2.6.0_@types+node@22.20.1_@vue+compiler-sfc@3.5.40_cac@6.7_4782438174415238735e8e3b36ed2074/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}